module.exports = __webpack_public_path__ + "img/blog-3.89df54ae.jpg";